/**
 * ============================================================================
 *  BACKWARD-COMPAT SHIM
 * ============================================================================
 *
 * Nội dung gốc đã được tách thành thư mục `./dynamic-form/`:
 *   - `./dynamic-form/constants` — enum / constant
 *   - `./dynamic-form/schema`    — Zod schema + helper parse
 *   - `./dynamic-form/types`     — kiểu suy diễn
 *
 * File này chỉ re-export để các caller hiện tại không phải đổi import path
 * trong cùng một PR. Khi rảnh, các file caller nên đổi sang import trực tiếp
 * từ '@/constant/dynamic-form' rồi xoá file shim này.
 */

export * from './dynamic-form';
